





























import { Component, Vue } from 'vue-property-decorator';
import { ModalConstants, BusConstants } from '@/core/constants';
import bus from '@/core/bus';
import { UserModule } from '../store/modules/user/user.store';
import { UserLoginRequest, UserLoginViewModel } from '../types/apiServerContract';

@Component
export default class Login extends Vue {
	id: string = ModalConstants.Login;

	email: string = '';
	password: string = '';
	loading: boolean = false;

	to: string = '';

	Login() {
	    this.loading = true;
	    const request: UserLoginRequest = {
	        email: this.email,
	        password: this.password
	    };

	    UserModule.Login(request)
	        .then((result: UserLoginViewModel) => {
	            this.$bvModal.hide(this.id);
	            if (this.to && this.to.length > 0) {
	                this.$router.push(this.to).catch(e => {});
	            }
	        })
	        .finally(() => (this.loading = false));
	}

	Reset() {
	    this.email = '';
	    this.password = '';
	}

	created() {
	    bus.on(BusConstants.LoginRequired, (to: string) => {
	        this.to = to;
	    });
	}

	beforeDestroy() {
	    bus.off(BusConstants.LoginRequired, (to: string) => {
	        this.to = '';
	    });
	}
}
